import styled from 'styled-components';

import FormControl from '@material-ui/core/FormControl';

export const MuiFormControl = styled(FormControl)`
    && {
        width: 100%;
    }
`;